export default "__VITE_ASSET__DATcZkwk__"